// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxFieldCustom_container__ZY4IB","checkmark":"CheckboxFieldCustom_checkmark__lOeNp"};